// extracted by mini-css-extract-plugin
module.exports = {"ERROR":"styles_ERROR__2nfv6","SUCCESS":"styles_SUCCESS__3nVhl","WARNING":"styles_WARNING__19kFz"};